@if (tabs) {
  <rask-tabs aid="tabs" [useRoute]="false" layout="child">
    @for (tab of visibleTabs; track tab) {
      <rask-tab (onTabSelected)="setTab(tab)" [label]="tab.name"></rask-tab>
    }
  </rask-tabs>
}
